export const NxAccordionConfig = {
  serviceInstance: new Object()
};